
export function b64EncodeUnicode (str: string) {
  if (!window.btoa || typeof window.btoa !== 'function') return str;
  return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => String.fromCharCode(('0x' + p1) as any)));
}

export function b64DecodeUnicode (str: string) {
  if (!window.atob || typeof window.atob !== 'function') return str;
  return decodeURIComponent(window.atob(str).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
}
